module.exports = __webpack_public_path__ + "static/media/wpe3.png.42726a02.jpg";